import Common from "../../js/waglebagle/common";

var DeleteMember = (function(Common) {
    var $btnDeleteMember = $("#btn_delete_member");

    var init = function() {
        var $iconContainer = $("#icon_all").closest("div");
        $iconContainer.data("checked", false);
        $iconContainer.on("click", function(e) {
            e.preventDefault();
            Common.checkIcon($(e.currentTarget));
        });

        $btnDeleteMember.on("click", e => {
            e.preventDefault();
            if (!$iconContainer.data("checked")) {
                alert("상기 사항을 모두 확인하시고, 체크해 주세요.");
                return;
            } else {
                deleteMember($btnDeleteMember.data("flag"));
            }
        });
    };

    const deleteMember = flag => {
        var delete_msg = "정말로 탈퇴 하시겠습니까?";

        if (confirm(delete_msg)) {
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "proc_mypage.htm",
                data: { rt: "ajax", ct: "delete_member" },
                success: function(json) {
                    if (json.ret == "succ") {
                        alert("탈퇴 처리가 되었습니다.");
                        location.replace("/");
                    } else if (json.error_msg) {
                        alert(json.error_msg);
                    } else {
                        alert(
                            "탈퇴처리 중 오류가 발생했습니다. 관리자에 문의해 주세요."
                        );
                    }
                }
            });
        }
    };

    return {
        init
    };
})(Common);

$(document).ready(function() {
    DeleteMember.init();
});



// WEBPACK FOOTER //
// ./mypage/js/delete_member.js